import { useCallback } from "react";
import { getRandomWelcomeBack, SCORE_EXPLANATION, RETURN_CTA } from "@hicya/habits-shared/data";

import { HabitIcon } from "@/components/ui/habit-icon";
import { useHabits } from "@/context/habits-context";

import styles from "./return-overlay.module.scss";

import type { Habit } from "@hicya/habits-shared/db";

interface ReturnOverlayProps {
  habits: Habit[];
  onDismiss: () => void;
}

export function ReturnOverlay({ habits, onDismiss }: ReturnOverlayProps) {
  const { updateSettings, state } = useHabits();

  const handleDismiss = useCallback(() => {
    void updateSettings("lastActiveDate", state.today);
    onDismiss();
  }, [updateSettings, state.today, onDismiss]);

  return (
    <div className={styles.overlay} data-testid="return-overlay">
      <div className={styles.content}>
        <p className={styles.welcomeBack}>{getRandomWelcomeBack()}</p>
        <p className={styles.explanation}>{SCORE_EXPLANATION}</p>

        <p className={styles.cta}>{RETURN_CTA}</p>
        <div className={styles.habitList}>
          {habits.slice(0, 6).map((habit) => (
            <button
              key={habit.id}
              type="button"
              className={styles.habitCard}
              onClick={handleDismiss}
              data-testid={`return-habit-${habit.id}`}
            >
              <span className={styles.habitIcon}>
                <HabitIcon value={habit.icon} />
              </span>
              <span className={styles.habitName}>{habit.name}</span>
            </button>
          ))}
        </div>

        <button
          type="button"
          className={styles.dismissButton}
          onClick={handleDismiss}
          data-testid="return-dismiss"
        >
          Dismiss
        </button>
      </div>
    </div>
  );
}
